import React from "react";

export default function HowItWorksBackground({src}) {
  return (
    <div className='how-it-works__bg-line'>
      <img src={src} role='presentation' />
    </div>
  );
}
